<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:otherStockInStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.otherStockInStatus === 'N'
              ? 'danger'
              : row.otherStockInStatus === 'A'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_otherStockInStatus }}
        </el-tag>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', { pageType: menuType, data })
          break
        case 'delete':
          this.del(data)
          break
        case 'audit':
          this.audit(data)
          break
      }
    },
    audit(row) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否要提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api
            .mrpOtherStockInAuditApi({
              mrpOtherStockInCode: row.mrpOtherStockInCode,
            })
            .then(() => {
              this.loadingClose()
              this.$message({
                showClose: true,
                message:
                  this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
                type: 'success',
              })
              this.$emit('reload')
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    del(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.mrpOtherStockInDelApi({ mrpOtherStockInCode: row.mrpOtherStockInCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
